'use client';

import { motion, HTMLMotionProps } from 'framer-motion';

type FadeInProps = HTMLMotionProps<'div'>;

const FadeIn: React.FC<FadeInProps> = ({ children, style, transition, viewport, ...rest }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5, ...transition }}
      viewport={{ once: true, margin: '0px 0px -100px 0px', ...viewport }}
      whileInView={{ opacity: 1, y: 0 }}
      style={{ width: '100%', ...style }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export default FadeIn;
